<template>
    <div class="modal" :class="{ 'open_modal': showImageUploadModal}">
        <div class="modal_overlay"></div>
        <div class="modal_inner max_height_80">
            <div class="modal_header"> 
                <span class="close_icon close_icon_sm" @click="closeModal()">×</span>
                <h2>{{ $t('special_lecture.image') }}</h2>
            </div>
            <div class="modal_wrapper">
                <div class="modal_content modal_1080p">
                    <div class="container">
                        <div class="row">
                            <div class="col_12">
                                <div :class="['form-group', {'has_error': errorFor('title')}]">
                                    <label>{{ $t('special_lecture.title') }}</label>
                                    <input type="text" class="form_global" v-model="image_form.title">
                                    <v-errors :errors="errorFor('title')" />
                                </div>
                            </div>
                            <div class="col_12">
                                <div :class="['form-group', {'has_error': errorFor('explanation')}]">
                                    <label>{{ $t('special_lecture.explanation') }}</label>
                                    <input type="text" class="form_global" v-model="image_form.explanation">
                                    <v-errors :errors="errorFor('explanation')" />
                                </div>
                            </div>
                            <div class="col_12">
                                <div :class="['form-group', {'has_error': errorFor('main_text')}]">
                                    <label>{{ $t('special_lecture.main_text') }}</label>
                                    <text-editor-component 
                                        :id="'main_text'" 
                                        :existingData="image_form.main_text ? image_form.main_text : ''" 
                                        @change="changeEditorValue"
                                    />
                                    <v-errors :errors="errorFor('main_text')" />
                                </div>
                            </div>
                            <div class="col_12">
                                <div class="d_flex_end">
                                    <button class="btn btn_blue ml_10 add_update" @click.prevent="submit()">{{ $t('special_lecture.upload_image') }}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import TextEditorComponent from "@/components/TextEditorComponent";
    export default {
        name:'image-upload-modal',
        components:{TextEditorComponent},
        data(){
            return{
                baseUrl: process.env.VUE_APP_BASE,
                image_form:{
                    title: '',
                    explanation: '',
                    main_text: '',
                },
            }
        },
        props:{
            showImageUploadModal:{
                type: Boolean,
                required: true
            },
            editableImageData:{
                type: Object,
                required: false
            }
        },
        created(){
            
        },
        mounted(){
            if(this.editableImageData){
                this.image_form = this.editableImageData
            }
        },
        methods:{
            closeModal(){
                this.$emit("closeModal");
            },
            submit(){
                this.$emit("addUploadedImage",this.image_form);
            },
            changeEditorValue(editorId, data){
                this.image_form[editorId] = data
            },
        }
    }
</script>

<style scoped>

</style>